import React from "react";

import { localizer } from "../../../Translator";

import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";
import Badge from '@material-ui/core/Badge';

import { AutocompleteStyled } from "../../common/InputStyled";
import { TextFieldStyled } from "../../common/InputStyled";
import TooltipStyled from "../../common/TooltipStyled"

import { SnackbarCustom } from "../../Utilities/SnackbarCustom";
import Validators from "../../Utilities/Validators";

import countries from '../../../resources/countries.json'
import streetTypes from '../../../resources/streetTypes.json'
import PostalCodeMask from "../../Utilities/PostalCodeMask";

/* Setting initial empty postal address state */
const initialState = {
  postalAddress: {
    id: null,
    who: "",
    contact: "",
    phone: "",
    identityCard: "",
    countryIso: "",
    locality: "",
    postalCode: "",
    streetType: "",
    streetName: "",
    streetNumber: "",
    streetComplements: "",
    envelopeBox: [],
    default: false,
    logo: null
  },

  countrySelected: "",
  streetTypeSelected: "",
      
  errormessage: null,
  logoPreview: null,
    errors: {},
}

export class PostalAddressModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  /* This component is used for add and edit, so in case a postal address is given, selects and inputs need to be charge with postal address information */
  componentDidMount() {
    this.setState(initialState, () => {
      if (this.props.postalAddress) {
        var countrySelected = countries.find(country => country.alpha2 === this.props.postalAddress.countryIso) !== undefined
          ? countries.find(country => country.alpha2 === this.props.postalAddress.countryIso)
          : countries.find(country => country.alpha2 === "es")
        /* var streetTypeSelected = streetTypes.find(streetType => streetType.name === this.props.postalAddress.streetType) !== undefined
          ? streetTypes.find(streetType => streetType.name === this.props.postalAddress.streetType)
          : streetTypes.find(streetType => streetType.name === "") */
                
        //let logoPreview = logoBase64 ? logoBase64 : null  
        let logoPreview = this.props.postalAddress.logo ? this.props.postalAddress.logo : null
      
        let errors = {}
        if (!Validators.documentIdentification(this.props.postalAddress.identityCard).isValid) {
          errors.identityCard = localizer.ValidationFieldTextIdCard
        } else {
          errors.identityCard = ""
        }
        
        this.setState({
          postalAddress: this.props.postalAddress,
          countrySelected: countrySelected,
          streetTypeSelected: "",
          logoPreview: logoPreview,
          errors: errors
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.postalAddress === this.props.postalAddress) return;

    this.setState(initialState, () => {
      if (this.props.postalAddress) {
        var countrySelected = countries.find(country => country.alpha2 === this.props.postalAddress.countryIso) !== undefined
          ? countries.find(country => country.alpha2 === this.props.postalAddress.countryIso)
          : countries.find(country => country.alpha2 === "es")
       /*  var streetTypeSelected = streetTypes.find(streetType => streetType.name === this.props.postalAddress.streetType) !== undefined
          ? streetTypes.find(streetType => streetType.name === this.props.postalAddress.streetType)
          : streetTypes.find(streetType => streetType.name === "") */
        
        let logoPreview = this.props.postalAddress.logo ? this.props.postalAddress.logo : null
        let errors = {}
        if (!Validators.documentIdentification(this.props.postalAddress.identityCard).isValid) {
          errors.identityCard = localizer.ValidationFieldTextIdCard
        } else {
          errors.identityCard = ""
        }
        this.setState({
          postalAddress: this.props.postalAddress,
          countrySelected: countrySelected,
          streetTypeSelected: "",
          logoPreview: logoPreview,
          errors: errors
        })
      }
    })
  }

  /* Handle onChange event for all text & number inputs */
  onInputchange = (event) => {
    this.setState(previousState => ({
      postalAddress: {
        ...previousState.postalAddress,
        [event.target.name]: event.target.value
      }
    }),
      () => {
        this.handleValidate(event.target.name)
      })
  }
  // Validate input data
  handleValidate = (inputName) => {
    let postalAddress = this.state.postalAddress
    let errors = this.state.errors

    switch (inputName) {
      case 'who':
        if (!postalAddress.who) {
          errors.who = localizer.ValidationFieldAddressee
        } else {
          errors.who = ""
        }
        break;
      case 'identityCard':
        if (postalAddress.identityCard) {
          if (!Validators.documentIdentification(postalAddress.identityCard).isValid) {
            errors.identityCard = localizer.ValidationFieldTextIdCard
          } else {
            errors.identityCard = ""
          }
        }
        break
      case 'locality':
        if (!postalAddress.locality) {
          errors.locality = localizer.ValidationFieldTextLocality
        } else {
          errors.locality = ""
        }
        break;
      case 'postalCode':
        if (!postalAddress.postalCode) {
          errors.postalCode = localizer.ValidationFieldTextPostalCode
        } else {
          errors.postalCode = ""
        }
        break;
      case 'streetName':
        if (!postalAddress.streetName) {
          errors.streetName = localizer.ValidationFieldTextDestinatioAddress
        } else {
          errors.streetName = ""
        }
        break;
    
      default:
        break;
    }
    this.setState({ errors: errors })
  }
  
  /**
  * When user change the country, countryISO and country selected from state must be refresh.  
  */
  handleCountriesSelect = (event, option) => {
    if (option !== null) {
      var countryIso = option.alpha2
      var countrySelected = countries.find(country => country.alpha2 === countryIso)

      this.setState(previousState => ({
        postalAddress: {
          ...previousState.postalAddress,
          countryIso: countryIso
        },
        countrySelected: countrySelected
      }))
    }
  }

  /**
   * When user change the street type, streetType and street type selected from state must be refresh.  
   */
  handleStreetSelect = (event, option) => {
    if (option !== null) {
      var streetType = option.name
      var streetTypeSelected = streetTypes.find(st => st.name === streetType)
      
      this.setState(previousState => ({
        postalAddress: {
          ...previousState.postalAddress,
          streetType: streetType
        },
        streetTypeSelected: streetTypeSelected
      }))
    }
  }

  /* Handle modal open/close events */
  doCloseModal = () => {
    this.setState({ postalAddress: this.props.postalAddress, errors: {} }, () => { this.props.handleCloseModal() })
  }

  /* Sending postal address edited or added to parent component to be stored */
  storePostalAddress = () => {
    let errors = this.validateAddress(this.state.postalAddress, "Sender")
    if (errors.length !== 0) {
      let errormessage = errors.map(error => { return error + " \n" })
      this.setState({ errormessage: errormessage })
      return
    }
    
    let option = this.state.postalAddress.id ? "PUT" : "POST"
    this.props.handlePostalAddress(this.state.postalAddress, option)
    if (!this.state.postalAddress.id) this.setState(initialState)
    this.props.handleCloseModal()
    //this.doCloseModal()
  }

  validateAddress = (address, target) => {
    let errors = []
    if (!address) {
      errors.push(localizer.AddressErrorEmpty)
      return errors
    }
    
    if (!address.who || address.who === "") errors.push(localizer.AddressErrorWho)
    let identification = Validators.documentIdentification(address.identityCard)
    if (!identification || (!identification.isValid)) errors.push(localizer.AddressErrorIdentification)
    if (!address.countryIso || address.countryIso === "") errors.push(localizer.AddressErrorCountryIso)
    if (!address.locality || address.locality === "") errors.push(localizer.AddressErrorLocality)
    if (!address.postalCode || address.postalCode === "") errors.push(localizer.AddressErrorPostalCode)
    if (!address.streetName || address.streetName === "") errors.push(localizer.AddressErrorStreetName)
    // Note: disabled this restriction: if (!address.streetNumber || address.streetNumber === "") errors.push(localizer.AddressErrorStreetNumber)
    
    if (address.postalCode && address.postalCode !== "" && address.countryIso && address.countryIso !== "" && (address.countryIso == "ES" || address.countryIso == "PT")) {
      let match = PostalCodeMask.checkPostalCodeMask(address.countryIso, address.postalCode)
      if (match === false) errors.push(localizer.AddressErrorPostalCodeMask)
    }
    
    if (address.who.length > 100) errors.push(localizer.AddressErrorLengthWho)
    if (address.streetName.length > 100) errors.push(localizer.AddressErrorLengthStreetName)
    
    let messagetarget = target === "RECIPIENT" ? localizer.AddressErrorDestination : localizer.AddressErrorSender
    if (errors.length !== 0) errors.unshift(messagetarget + localizer.AddressError)

    return errors
  }

  handleonClose = () => {
    this.setState({ errormessage: null })
  }

  handleOnChangeUploadLogo = async (event) => {
    var files = event.target.files
    if (files.length === 0) return
   
    const file = event.target.files[0];

    
    /*intentando ver tamaño por si me piden validación */
    let img = new Image();
    img.src = URL.createObjectURL(event.target.files[0]);
    
    /* img.onload = await function () {
      var width = this.naturalWidth
      var height = this.naturalHeight
    } */

    const base64 = await this.convertBase64(file);
    this.setState(previousState => ({
      postalAddress: {
        ...previousState.postalAddress,
        logo: base64
      },
      logoPreview: base64
    }))
  }

  /**
   * convert image to Base64
   */
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  render() {
    return (
      <React.Fragment>
        <Dialog
          open={this.props.openModal}
          onClose={this.doCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"md"}
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseModal}></i>
            <Typography className="typography-generic dialog-title"> {this.state.postalAddress && this.state.postalAddress.id ? localizer.PostalAddressEdit : localizer.PostalAddressAdd}</Typography>

          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content" >
            <Grid container spacing={2} direction="row" justify="center" alignItems="center">
              <Grid container item direction="row" spacing={2}>
                <Grid item md={4} >
                  {/* Identity Card field */}
                  <TooltipStyled className="tooltip-custom-w" placement="top-end" title={
                    <React.Fragment>
                      <Typography className="typography-generic small"><b>NIF:</b> <span style={{ opacity: "0.6" }}>07806892W</span></Typography>
                      <Typography className="typography-generic small"><b>NIE:</b> <span style={{ opacity: "0.6" }}>X7120951J</span></Typography>
                      <Typography className="typography-generic small"><b>CIF:</b> <span style={{ opacity: "0.6" }}>R9178125B</span></Typography>
                    </React.Fragment>
                  }>
                    <Badge
                      badgeContent={<i className="fa-solid fa-info"></i>}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      className="badge-info"
                      style={{ width: "100%" }}>
                      <TextFieldStyled id="textfield-identifycard" label={<Typography className="typography-generic">{localizer.AddresseDocumentId}</Typography>}
                        name="identityCard"
                        value={this.state.postalAddress ? this.state.postalAddress.identityCard : ""}
                        onChange={this.onInputchange}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          classes: {
                            input: "typography-generic"
                          },
                          inputProps: { maxLength: 100 }
                        }}
                      />
                    </Badge>
                  </TooltipStyled>
                  <span style={{ color: "red" }}>{this.state.errors.identityCard}</span>
                </Grid>
                {/* Phone and contact fields removed due to the fact that it is not used in the new address format */}
                {/* <Grid item md={4} >
                  <TextFieldStyled id="pa-phone" name="phone" autoComplete="off" variant="outlined"
                    label={<Typography className="typography-generic">{localizer.PostalAddressPhone} </Typography>}
                    value={this.state.postalAddress ? this.state.postalAddress.phone : ""} onChange={this.onInputchange}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                  />
                </Grid> */}
              </Grid>

              <Grid container item direction="row" spacing={2}>
                {/* Who Field */}
                <Grid item md={12}>
                  <TextFieldStyled id="pa-who"
                    name="who"
                    autoComplete="off"
                    label={<Typography className="typography-generic">{localizer.PostalAddressWho}</Typography>}
                    value={this.state.postalAddress ? this.state.postalAddress.who : ""}
                    onChange={this.onInputchange}
                    variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic",
                      },
                      inputProps: { maxLength: 100 }
                    }}
                  />
                  <span style={{ color: "red" }}>{this.state.errors.who}</span>
                </Grid>
              </Grid>
              
              {/* Full address will be contain in streetName field, so streetType, streetNumber and streetComplements are not needed */}
              <Grid container item direction="row" spacing={2}>
                {/* Full address Field */}
                <Grid item md={12}>
                  <TextFieldStyled id="pa-streetName"
                    name="streetName"
                    autoComplete="off"
                    label={<Typography className="typography-generic">{localizer.FullAddress}</Typography>}
                    value={this.state.postalAddress ? this.state.postalAddress.streetName : ""}
                    onChange={this.onInputchange}
                    variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      },
                      inputProps: { maxLength: 100 }
                    }}
                  /> <span style={{ color: "red" }}>{this.state.errors.streetName}</span>
                </Grid>
              </Grid>

              <Grid container item direction="row" spacing={2}>
                {/* Postal Code field */}
                <Grid item md={2}>
                  <TextFieldStyled id="pa-postalCode"
                    name="postalCode"
                    autoComplete="off"
                    label={<Typography className="typography-generic">{localizer.PostalAddressPostalCode}</Typography>}
                    value={this.state.postalAddress ? this.state.postalAddress.postalCode : ""}
                    onChange={this.onInputchange}
                    variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      },
                      inputProps: { maxLength: 100 }
                    }} />
                  <span style={{ color: "red" }}>{this.state.errors.postalCode}</span>
                </Grid>
                {/* Locality field */}
                <Grid item md={6}>
                  <TextFieldStyled id="pa-locality"
                    name="locality"
                    autoComplete="off"
                    label={<Typography className="typography-generic">{localizer.PostalAddressLocality}</Typography>}
                    value={this.state.postalAddress ? this.state.postalAddress.locality : ""}
                    onChange={this.onInputchange}
                    variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      },
                      inputProps: { maxLength: 100 }
                    }} />
                  <span style={{ color: "red" }}>{this.state.errors.locality}</span>
                </Grid>
                <Grid item md={4}>
                  <AutocompleteStyled
                    id="countries"
                    classes={{ input: 'typography-generic', option: 'typography-generic' }}
                    options={countries}
                    getOptionLabel={(option) => (option.name ? option.name : '')}
                    getOptionSelected={(option, value) => option.value === value.value}
                    renderInput={(params) => <TextFieldStyled {...params} autoComplete="off" label={<Typography className="typography-generic">{localizer.PostalAddressCountryIso}</Typography>} variant="outlined" />}
                    onChange={this.handleCountriesSelect}
                    value={this.state.countrySelected}
                    fullWidth
                  />
                </Grid>
              </Grid>
              {/* DO NOT DELETE!!: this is about uploading an image that defines the postal address
              <Grid container item direction="row">
                <Grid item md={this.state.logoPreview ? 2 : 12}>
                  <input
                    accept="image/*"
                    id="contained-button-file"
                    type="file"
                    style={{ display: "none" }}
                    onChange={this.handleOnChangeUploadLogo}
                  />
                  <label htmlFor="contained-button-file" style={{ width: "100%" }}>
                    <Button className="button-generic dialog-secondary" variant="outlined" component="span" startIcon={<i className="fa-regular fa-file-image"></i>}>
                      {localizer.PostalAddressUploadLogo}
                    </Button>
                  </label>
                </Grid>
                {this.state.logoPreview && (
                  <Grid item md={10}>
                    <img className="viewer-container ml-20" src={this.state.logoPreview} alt="Logo" width={95}></img>
                    <Typography className="typography-generic ml-20">({localizer.PostalAddressLogoPreview})</Typography>
                  </Grid>
                )}
              </Grid> */}

              <Grid container item md={12} direction="row" spacing={2} justify="flex-end">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.doCloseModal}>{localizer.Cancel}</Button>
                <Button className="button-generic dialog-primary" variant="contained" onClick={this.storePostalAddress}> {this.state.postalAddress && this.state.postalAddress.id ? localizer.Edit : localizer.Add}</Button>
              </Grid>

            </Grid>
          </DialogContent>
          {/* Error message for address fields validation */}
          <SnackbarCustom message={this.state.errormessage} severity="error" handleonClose={this.handleonClose} />
        </Dialog>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/postal-address/sections/PostalAddressModal.js